import { PdfDocument } from '../@types/Acertei';
import Service from './Service';

class PdfDocumentService extends Service {
  static create(title: string, fileKey: string) {
    return this.Http.post<PdfDocument>('/pdf-documents', { title, file_key: fileKey }).then(this.getData);
  }

  static list() {
    return this.Http.get<PdfDocument[]>('/pdf-documents').then(this.getData);
  }

  static replace(pdfDocId: string, newFileKey: string) {
    return this.Http.patch(`/pdf-documents/${pdfDocId}/replace`, { file_key: newFileKey }).then(this.getData);
  }

  static reviewStatus(pdfDocId: string) {
    return this.Http.get<{ total: number; pending: number }>(
      `/pdf-documents/${pdfDocId}/review-status`
    ).then(this.getData);
  }

  static delete(pdfDocId: string) {
    return this.Http.delete(`/pdf-documents/${pdfDocId}`).then(this.getData);
  }
}

export default PdfDocumentService;
